module.exports = __webpack_public_path__ + "ed934865f0334e21b1b1e4aacb8ad839.pdf";